/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSuggestResearchSettingsResponseFromDiscriminatorValue, serializeSuggestResearchSettingsRequest, serializeSuggestResearchSettingsResponse, type ErrorResponse, type InternalErrorResponse, type SuggestResearchSettingsRequest, type SuggestResearchSettingsResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/research-settings/suggest
 */
export interface SuggestRequestBuilder extends BaseRequestBuilder<SuggestRequestBuilder> {
    /**
     * Researches the caller's own organization on the web and returns suggested industry description and B2B approval criteria. Suggestions are not persisted; the admin reviews them and saves via PUT /api/organizations/research-settings. Returns 400 when settings are already configured unless forceRegenerate is true.
     * @param body Asks the research model to draft research settings for the caller's own organization. Nothing ispersisted — the suggestions are a starting point the admin edits and then saves throughPUT /api/organizations/research-settings.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SuggestResearchSettingsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: SuggestResearchSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SuggestResearchSettingsResponse | undefined>;
    /**
     * Researches the caller's own organization on the web and returns suggested industry description and B2B approval criteria. Suggestions are not persisted; the admin reviews them and saves via PUT /api/organizations/research-settings. Returns 400 when settings are already configured unless forceRegenerate is true.
     * @param body Asks the research model to draft research settings for the caller's own organization. Nothing ispersisted — the suggestions are a starting point the admin edits and then saves throughPUT /api/organizations/research-settings.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SuggestResearchSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SuggestRequestBuilderUriTemplate = "{+baseurl}/api/organizations/research-settings/suggest";
/**
 * Metadata for all the requests in the request builder.
 */
export const SuggestRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: SuggestRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSuggestResearchSettingsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSuggestResearchSettingsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
